import { FileProps } from "../../../types/generic";
import { workflowInstance_V2 } from "../../api";
import { callApi } from "../../generic";

export const getAttachments = async (
  vesselCode: string,
  ctoCode: string,
  fileCode: number,
  shouldUseHistory: boolean,
): Promise<Blob> =>
  callApi(() =>
    workflowInstance_V2.get(
      `vessel/${vesselCode}/cto/${ctoCode}/file/${fileCode}?use_history=${shouldUseHistory}`,
      {
        responseType: "blob",
      },
    ),
  );

export const postAttachments = async (
  vesselCode: string,
  ctoCode: string,
  formData: FormData,
  type?: string,
): Promise<FileProps[]> => {
  if (type) {
    formData.append("type", type);
  }
  return callApi(() =>
    workflowInstance_V2.post(
      `vessel/${vesselCode}/cto/${ctoCode}/file`,
      formData,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      },
    ),
  );
};

export const deleteAttachments = async (
  vesselCode: string,
  ctoCode: string,
  fileId: number,
): Promise<{ message: string }> =>
  callApi(() =>
    workflowInstance_V2.delete(
      `vessel/${vesselCode}/cto/${ctoCode}/file/${fileId}`,
    ),
  );

export const service = {
  getAttachments,
  postAttachments,
  deleteAttachments,
};
